import React, {useState, memo, useEffect} from 'react';
import {Head, Loading} from "../../components";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {Box, Tooltip} from "@mui/material";
import CurrencyFormat from "react-currency-format";
import Api from "../../utils/api";
import OperatorTicketExport from "./excel";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import Grid from "@mui/material/Grid";
import {DatePicker} from "zaman";
import moment from "moment-jalaali";
import Divider from "@mui/material/Divider";
import AccordionActions from "@mui/material/AccordionActions";
import Button from "@mui/material/Button";

const TicketReport = ( props ) => {

    const [loading, setLoading] = useState(false);
    const [entities, setEntities] = useState([]);
    const [filter, setFilter] = useState({
        from_date: '',
        to_date: '',
    });

    const handleRequest = () => {
        setLoading(true);
        new Api().get('/tickets/operator/report', filter, false).then((response) => {
            if (typeof response !== "undefined") {
                setEntities(response);
            }

            setLoading(false);
        })
    }


    useEffect(() => {
        handleRequest();
    }, [filter.from_date, filter.to_date]);


    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'عملکرد اپراتورها', 'description': 'براساس نظرسنجی کاربران' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography >جستجو</Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3}>
                                <div className='datepicker-input-container'>
                                    <label>از تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            let n_filter = filter;
                                            n_filter["from_date"] = moment(value.value).locale('en').format('YYYY/MM/DD HH:mm:ss');
                                            setFilter({...n_filter});
                                        }}
                                    />

                                </div>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <div className='datepicker-input-container'>
                                    <label>تا تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            let n_filter = filter;
                                            n_filter["to_date"] = moment(value.value).locale('en').format('YYYY/MM/DD HH:mm:ss');
                                            setFilter({...n_filter});
                                        }}
                                    />

                                </div>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <OperatorTicketExport entities={entities} />
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>نام کاربر</th>
                        <th>تعداد کل پاسخ</th>
                        <th>راضی</th>
                        <th>ناراضی</th>
                        <th>بدون نظر</th>
                    </tr>
                    </thead>
                    <tbody>
                    {entities.length > 0 && entities.map((item, index) => {
                        return(
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.full_name}</td>
                                <td><CurrencyFormat value={item.total} displayType={'text'} thousandSeparator={true}  /></td>
                                <td><CurrencyFormat value={item.yes_counter} displayType={'text'} thousandSeparator={true}  /></td>
                                <td><CurrencyFormat value={item.no_counter} displayType={'text'} thousandSeparator={true}  /></td>
                                <td><CurrencyFormat value={item.no_ans_counter} displayType={'text'} thousandSeparator={true}  /></td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            {loading && <Loading/>}
        </Container>

    );
}


export default memo(TicketReport);
